module.exports = __webpack_public_path__ + "static/iwoca-no-sales-revenue-based-loan-graph-dfb6bdf3b45277be90679545be9987ea.svg";